let AuthLib;
let authIsLoading = false;
let loadingPromise;
async function getAuth() {
  if (!AuthLib && !authIsLoading) {
    authIsLoading = true;
    loadingPromise = Promise.all([
      import(/* webpackChunkName: "awsAmplify_auth", webpackPrefetch: true */ '@aws-amplify/auth'),
      import(/* webpackChunkName: "awsAmplify_auth", webpackPrefetch: true */ '../config/aws'),
    ]).then(([mod, config]) => {
      authIsLoading = false;
      AuthLib = mod.default;
      AuthLib.configure(config.default);
      return AuthLib;
    });
    return loadingPromise;
  } else if (!AuthLib && authIsLoading) {
    return loadingPromise;
  }

  return AuthLib;
}
class Cognito {
  static async fetchCognitoCredentials() {
    try {
      const Auth = await getAuth();
      const response = await Auth.currentAuthenticatedUser();
      const { signInUserSession } = response || {};
      const { idToken } = signInUserSession || {};
      const { payload, jwtToken } = idToken || {};
      const { email, family_name, 'fc-id': fcId, given_name } = payload || {};
      if (fcId && jwtToken) {
        return {
          token: jwtToken,
          userID: fcId,
          email,
          'first-name': given_name,
          'last-name': family_name,
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }
}

export default Cognito;
